var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 71,
    height: 69.5275,
    rx: 34.7637,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6616 22.6831C48.7736 21.5564 48.7736 20.5417 48.7736 19.3008H26.2261C26.2261 20.5417 26.2261 21.5564 26.3381 22.6831H19.4614V23.8099C19.4614 33.8449 32.2023 40.9478 35.2464 42.5248L35.2443 46.3595C35.2443 48.2769 33.7793 49.7418 31.862 49.7418H29.6063V54.2509H45.3913V49.7418H43.1357C41.2183 49.7418 39.7534 48.2769 39.7534 46.3595V42.5269C42.7975 40.9477 55.5384 33.8448 55.5384 23.812V22.6852L48.6616 22.6831ZM21.829 24.9387H26.5643C27.0146 30.0123 28.2555 33.6208 29.6084 36.2125C25.9999 33.3946 22.2793 29.4478 21.829 24.9387ZM45.5054 36.2125C46.8584 33.6186 48.0993 30.0123 48.5495 24.9387H53.2848C52.7204 29.4478 48.9998 33.3946 45.5054 36.2125Z",
    fill: "#311B92"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 71,
    height: 69.5275,
    rx: 34.7637,
    stroke: "#9575CD",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.bd6222410b896905dbcc8765c91f3c79.svg";
export { ForwardRef as ReactComponent };